import { Box, Card, Divider, Grid, Paper } from "@mui/material";
import { Header } from "../common/Header";
import { useAppDispatch } from "../../store/store";
import { useEffect } from "react";
import { GetOptimizationModels, clearOptimizationData } from "../../store/optimization-slice/optimization";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import RedirectIconButton from '../common/RedirectIconButton';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import OptimizationModelSelection from "./OptimizationModelSelection";
import OptimizationModel from "./OptimizationModel";
import OptimizationsTable from "./OptimizationsTable";

interface MLOptimizationProps {
    modelId?: string | null;
    modelName?: string | null;
    showModelSelection?: boolean
}

const MLOptimization: React.FC<MLOptimizationProps> = ({ modelId, modelName, showModelSelection }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const [searchParams] = useSearchParams();
    const optimizationDataId = searchParams.get('id');
    const optimizationDataName = searchParams.get('name');
    
    useEffect(() => {
        dispatch(GetOptimizationModels());

        return () => {
            dispatch(clearOptimizationData());
        }
    }, []);
    
    // If parent passed props, prefer those. Otherwise fall back to ?id=…&name=… from URL.
    const propModelId = modelId ?? optimizationDataId
    const propModelName = modelName ?? optimizationDataName

    return(
        <Box sx={{ margin: "0 auto" }}>
            { 
                showModelSelection &&
                <Card elevation={3} sx={{ mb: 3, borderRadius: 2 }}>
                    <Header
                        title={t("OPTIMIZATION_TITLE")}
                        helperIcon={
                            <RedirectIconButton to={"/help/5"} className="helper-icon">
                                <ContactSupportIcon />
                            </RedirectIconButton>
                        }
                    />
                    <Box sx={{ p: 1.5 }}>
                        <Box sx={{ mb: 0.5, fontSize: '1.1rem', fontWeight: 'bold' }}>
                            {t('OPTIMIZATIONS_SELECT_MODEL')}
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <OptimizationModelSelection optimizationDataId={propModelId} />
                    </Box>
                </Card>
            }

            {propModelId && propModelName && (
                <>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
                                <Box sx={{ mb: 0.5, fontSize: '1.1rem', fontWeight: 'bold' }}>
                                    {t('NEW_OPTIMIZATION_TITLE')}
                                </Box>
                                <Divider sx={{ mb: 2 }} />
                                <OptimizationModel 
                                    optimizationDataId={propModelId} 
                                    optimizationDataName={propModelName} 
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
                                <Grid container sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Grid item sx={{ width: '100%', overflowY: 'auto' }}>
                                        <OptimizationsTable optimizationDataId={propModelId} />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </>
            )}
        </Box>
    )
}

export default MLOptimization;